// Service di comunicazione con i backend (CEO/CBB)

import Axios from "axios";
import { FORMAT, ERROR } from "../utils/Constants.js";
import i18n from "../i18n";

var JSONbig = require("json-bigint")({ storeAsString: true });
// serve a gestire il diverso formato dei long tra java e javascript (64 vs 52 bit)

const CEOURL = process.env.https://uvote4.cineca.it/;
const CBBURL = process.env.https://uvote4.cineca.it/;
const apiPrefix = process.env.VUE_APP_apiPrefix;
const AUTHMETHOD = "USERNAME-PASSWORD"; // non dovrebbe più servire

class CeoCbbService {
  ceourl;
  cbbUrl;
  token;
  headersJson;
  keycloak;
  alertContacts;
  specificLogoutUrl;

  constructor(keycloak) {
    this.ceourl = CEOURL;
    this.cbbUrl = CBBURL;
    this.token = keycloak.token;
    this.keycloak = keycloak;

    if (!this.token) {
      return this.showErrorMessageAndExit(
        i18n.t("error.AUTHENTICATION_FAILED")
      );
    }

    this.headersJson = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.token
        //   withCredentials: true
        //crossdomain: true,
        // TODO: verificare gli header in fase di hardening
        //"Access-Control-Allow-Origin": "*",
        //"Access-Control-Allow-Methods":
        // "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        //"Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        //"X-Forwarded-Proto": "https",
        //"X-Forwarded-Port": 443
      }
    };
  }

  alertContactsSetter(alertContacts) {
    this.alertContacts = alertContacts;
  }
  specificLogoutUrlSetter(specificLogoutUrl) {
    this.specificLogoutUrl = specificLogoutUrl;
  }

  getLogoutUrl() {
    let endpoint = "/logout";
    return this.ceourl + apiPrefix + endpoint;
  }

  showErrorMessageAndExit(
    errorMessage = "",
    consoleErrorMessage = "",
    doExit = true
  ) {
    if (errorMessage) {
      alert(errorMessage + "\n\n" + this.alertContacts);
    }

    if (doExit) {
      if (this.specificLogoutUrl) {
        window.location.href = this.getLogoutUrl();
      } else {
        this.keycloak.logoutFn();
      }
    }

    return;
  }

  async genericPostCallWithAlert(
    name,
    url,
    headers,
    fields,
    extra,
    errorMessage = "",
    consoleErrorMessage = "",
    doExit = true
  ) {
    let response = await this.genericPostCall(
      name,
      url,
      headers,
      fields,
      extra
    );

    if (response.status !== 200) {
      return this.showErrorMessageAndExit(
        errorMessage,
        consoleErrorMessage ? consoleErrorMessage : response.data.error,
        doExit
      );
    } else {
      return response.data;
    }
  }

  async genericPostCall(name, url, headers, fields, extra) {
    const options = Object.assign(extra || {}, headers);
    // console.debug(`[CeoCbbService:${name}] Calling ${url} with options`, options);

    let response = await Axios.post(url, fields, options)
      .catch(error => {
        //console.error(`[CeoCbbService:${name}] Error`, error.response.data);

        //risposta INTERNAL_SERVER_ERROR
        if (error.response.status === 500) {
          return this.showErrorMessageAndExit(
            i18n.t("error.SERVER_ERROR"),
            error.response.data
          );
        } else if (
          //risposta UNAUTHORIZED O FORBIDDEN
          error.response.status === 401
        ) {
          // let errorMessage = this.keycloak.authenticated
          //   ? ERROR.SESSION_EXPIRED + FORMAT.NL
          //   : FORMAT.EMPTY;
          let errorMessage = i18n.t("error.SERVICE_ACCESS_NOT_AUTHORIZED");

          return this.showErrorMessageAndExit(
            errorMessage,
            error.response.data
          );
        } else if (error.response.status === 403) {
          let errorMessage =
            i18n.t("error.SERVICE_ACCESS_NOT_AUTHORIZED") +
            "\n" +
            error.response.data.message;
          return this.showErrorMessageAndExit(
            errorMessage,
            error.response.data
          );
        } else if (error.response.status === 412) {
          let res =
            i18n.t("error.VOTING_ACCESS_NOT_AUTHORIZED") +
            FORMAT.NL +
            i18n.t("error.VERIFY_SCHEDULING");
          return this.showErrorMessageAndExit(res, error.response.data);
        } else return error.response;
      })
      .then(response => {
        //console.log(response);

        //risposta OK
        if (response.status === 200) {
          return response;
        }
        //risposta SERVICE_UNAVAILABLE
        if (response.status === 503) {
          return this.showErrorMessageAndExit(
            i18n.t("error.SERVER_CONNECTION_ERROR")
          );
        } else {
          return response;
        }
      });

    // console.log(`[CeoCbbService:${name}]: Returned data`, response.data);
    return response;
  }

  // ***** CHIAMATE A CEO *****

  async voterIdentification(eventId, voterId) {
    let endpoint = "/voter_identification";
    let fields = {
      Id: "CEO_VOTERIDENTIFICATION_REQUEST",
      Channel: {
        Type: "KVC", // I canali vengono ignorati. Sono gestiti direttamente lato server
        Id: "KVC",
        AuthenticationMethod: AUTHMETHOD
      },
      eventId: eventId,
      voterId: voterId
    };

    return await this.genericPostCallWithAlert(
      "voterIdentification",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      i18n.t("error.VOTER_IDENTIFICATION")
    );
  }

  async getElectionEvents() {
    let endpoint = "/election_events";
    let fields = {};

    return await this.genericPostCallWithAlert(
      "electionEvent",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      i18n.t("error.ELECTION_EVENT")
    );
  }

  async getElectionEvent(eventId, voterId) {
    let endpoint = "/election_event";
    let fields = {
      Id: eventId,
      EventIdentifier: {
        Id: eventId
      },
      eventId: eventId,
      voterId: voterId
    };

    return await this.genericPostCallWithAlert(
      "electionEvent",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      i18n.t("error.ELECTION_EVENT")
    );
  }

  async openingVotingSession(eventId, voterId) {
    let endpoint = "/voting_session_opening";
    let fields = {
      eventId: eventId,
      voterId: voterId
    };

    return await this.genericPostCallWithAlert(
      "votingSessionOpening",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      i18n.t("error.OPEN_VOTING_SESSION")
    );
  }

  async closingVotingSession(voterId, eventId) {
    let endpoint = "/voting_session_closing";
    let fields = {
      Id: "xxx", //TODO: tutti questi ID non servono a niente
      Channel: {
        Type: "KVC",
        Id: "KVC",
        AuthenticationMethod: AUTHMETHOD
      },
      VoterIdentifier: {
        VoterId: [voterId]
      },
      eventId: eventId,
      voterId: voterId
    };

    return await this.genericPostCallWithAlert(
      "votingSessionClosing",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      i18n.t("error.CLOSE_VOTING_SESSION")
    );
  }
  async getElectionsList(voterId, eventId) {
    let endpoint = "/voter_ballots_status";
    let fields = {
      Id: "xxx", //TODO: tutti questi ID non servono a niente
      Channel: {
        Type: "KVC",
        Id: "KVC",
        AuthenticationMethod: AUTHMETHOD,
        EventIdentifier: {
          Id: eventId
        }
      },
      VoterIdentifier: {
        VoterId: [voterId]
      },
      eventId: eventId,
      voterId: voterId
    };

    return await this.genericPostCallWithAlert(
      "getElectionsList",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      i18n.t("error.ELECTION_LIST")
    );
  }

  async getElection(eventId, electionId, voterId) {
    let endpoint = "/election_voting_information";
    let fields = {
      EventIdentifier: {
        Id: eventId
      },
      ElectionIdentifier: [
        {
          Id: electionId
        }
      ],
      eventId: eventId,
      voterId: voterId
    };

    return await this.genericPostCallWithAlert(
      "getElection",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      i18n.t("error.ELECTION")
    );
  }

  async getContest(eventId, contestId, voterId) {
    let endpoint = "/choices_contest";
    let fields = {
      EventIdentifier: {
        Id: eventId
      },
      ChoicesContestIdentifier: [
        {
          Id: contestId
        }
      ],
      eventId: eventId,
      voterId: voterId
    };

    return await this.genericPostCallWithAlert(
      "getContest",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      i18n.t("error.CONTEST")
    );
  }

  async getBallotSignature(bsr) {
    let endpoint = "/ballot_signature";
    let fields = bsr;

    return await this.genericPostCallWithAlert(
      "getBallotSignature",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      { transformResponse: data => JSONbig.parse(data) },
      i18n.t("error.BALLOT_SIGNATURE")
    );
  }

  async makeAbstention(electionId, eventId, voterId) {
    let endpoint = "/make_abstention";
    let fields = {
      electionId: electionId,
      eventId: eventId,
      voterId: voterId
    };

    //console.log("LOCALE", i18n.locale);
    return await this.genericPostCallWithAlert(
      "makeAbstention",
      this.ceourl + apiPrefix + endpoint,
      this.headersJson,
      fields,
      {},
      i18n.t("error.MAKE_ABSTENSION")
    );
  }

  // ***** CHIAMATE A CBB *****

  // L'autenticazione è gestita manualmente attraverso le credenziali OTP rilasciate da CEO
  // nelle chiamate 'getBallotSignature' e 'makeabstention'
  async ballotToBallotBox(ballotToken, xml, transId) {
    let endpoint = "/cbb/ballot_to_ballot_box";
    let username = ballotToken.RandomUsername;
    let password = ballotToken.RandomPassword;
    let fields = {
      TransactionId: transId,
      SignedCryptedBallot: {
        EventId: ballotToken.EventIdentifier.Id,
        ElectionGroupId: ballotToken.ElectionIdentifier.ElectionGroup.Id,
        ElectionId: ballotToken.ElectionIdentifier.Id,
        value: xml
      }
    };
    let headersJson = {
      headers: {
        "Content-Type": "application/json",
        username: username,
        password: password
        //crossdomain: true,
        //"Access-Control-Allow-Origin": "*",
        //"Access-Control-Allow-Methods":
        //  "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        //"Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        //"X-Forwarded-Proto": "https",
        //"X-Forwarded-Port": 443
      }
    };

    return await this.genericPostCallWithAlert(
      "ballotToBallotBox",
      this.ceourl + apiPrefix + endpoint,
      headersJson,
      fields,
      {},
      i18n.t("error.BALLOT_TO_BALLOT_BOX")
    );
  }

  async ballotDelete(electionId, eventId, username, password) {
    let endpoint = "/cbb/delete_ballot";
    let fields = {};
    let headersJson = {
      headers: {
        "Content-Type": "application/json",
        username: username,
        password: password,
        election_id: electionId,
        event: eventId
        //crossdomain: true,
        //"Access-Control-Allow-Origin": "*",
        //"Access-Control-Allow-Methods":
        //  "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        //"Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        //"X-Forwarded-Proto": "https",
        //"X-Forwarded-Port": 443
      }
    };
    // console.log(headersJson);

    return await this.genericPostCallWithAlert(
      "ballotDelete",
      this.ceourl + apiPrefix + endpoint,
      headersJson,
      fields,
      {},
      i18n.t("error.BALLOT_DELETE")
    );
  }
}

export default CeoCbbService;
